import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// ── Shriftlar ────────────────────────────────────────────────────────────
// Loyihaning o'zidan beriladi (@fontsource), Google Fonts'dan emas.
// Sabab: har bir ish o'rni sahifa ochilganda tashqi serverga so'rov
// yubormasin (kiberjinoyatlarga qarshi kurash boshqarmasi uchun bu muhim)
// va internet cheklangan tarmoqda ham interfeys to'g'ri ko'rinsin.
//
// Faqat kerakli alifbolar ulanadi:
//   latin      — o'zbekcha (lotin) va inglizcha
//   latin-ext  — o'zbekchadagi maxsus harflar (oʻ, gʻ)
//   cyrillic   — ruscha va o'zbekcha (kirill) murojaatlar
//   cyrillic-ext
// Yunon va vetnam subsetlari ataylab qoldirildi — ular CSS ni ikki barobar
// kattalashtirardi, lekin bu tizimda hech qachon ishlatilmaydi.
//
// Og'irliklar DESIGN.md 3-bo'limi bo'yicha uchta: 400 / 500 / 600.
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-ext-400.css'
import '@fontsource/inter/latin-ext-500.css'
import '@fontsource/inter/latin-ext-600.css'
import '@fontsource/inter/cyrillic-400.css'
import '@fontsource/inter/cyrillic-500.css'
import '@fontsource/inter/cyrillic-600.css'
import '@fontsource/inter/cyrillic-ext-400.css'
import '@fontsource/inter/cyrillic-ext-500.css'
import '@fontsource/inter/cyrillic-ext-600.css'

import '@fontsource/jetbrains-mono/latin-400.css'
import '@fontsource/jetbrains-mono/latin-500.css'
import '@fontsource/jetbrains-mono/latin-600.css'
import '@fontsource/jetbrains-mono/latin-ext-400.css'
import '@fontsource/jetbrains-mono/cyrillic-400.css'
import '@fontsource/jetbrains-mono/cyrillic-500.css'

// ── Uslublar: TARTIB MUHIM, o'zgartirmang ──────────────────────────────
// 1) Kit — poydevor: tokenlar va `ui-*` komponentlari.
// 2) index.css — ilova qatlami: eski sinf nomlarini kitga ulaydi va kerak
//    bo'lganda kit qoidalarini bosib o'tadi.
//
// Nima uchun kit aynan SHU YERDA, birinchi bo'lib ulanadi: CSS'da bir xil
// spetsifiklikda keyingi qoida ustun chiqadi, ya'ni faylni yuklash tartibi
// ko'rinishni belgilaydi. Ilgari kit ikki joydan kelardi (index.css dagi
// @import va src/ui/index.jsx dagi JS import) va yakuniy tartibni Vite'ning
// modul grafigi hal qilardi — natijada kit index.css'dan KEYIN tushib,
// ilova qatlamini bosib o'tardi. Aynan shu tufayli yon paneldagi "..."
// menyusi ko'rinmay qolgan edi.
//
// Endi tartib bu yerda qat'iy belgilanadi. src/ui/index.jsx dagi
// `import './kit.css'` joyida qoladi (kit boshqa loyihaga ko'chirilganda
// uslub o'zi bilan kelishi uchun), lekin u grafikda keyin uchraydi va
// Vite takroriy CSS'ni chiqarmaydi — ya'ni dublikat ham, tartib buzilishi
// ham yo'q.
import './ui/kit.css'
import './index.css'

import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
